/* GOCCE DERİ | v4 motion: independent card galleries, filter drawer, sort, and home rail. */
(() => {
  'use strict';
  const d = document;
  const clamp = (n, min, max) => Math.max(min, Math.min(max, n));
  const reduced = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initGalleries(scope) {
    scope.querySelectorAll('[data-gocce-v4-gallery]:not([data-v4-ready])').forEach(gallery => {
      gallery.dataset.v4Ready = '1';
      const track = gallery.querySelector('[data-gocce-v4-track]');
      const count = track?.children.length || 0;
      if (!track || count < 2) return;
      const dots = [...gallery.querySelectorAll('[data-gocce-v4-dot]')];
      const prev = gallery.querySelector('[data-gocce-v4-prev]');
      const next = gallery.querySelector('[data-gocce-v4-next]');
      const slideLink = gallery.querySelector('.gocce-v4-media-link');
      let index = 0, isDown = false, downX = 0, downY = 0, downAt = 0;
      let dragged = false, ignoreLinkUntil = 0, hoverTimer, leaveTimer;
      const go = (target, wrap = false) => {
        const nextIndex = wrap ? (target + count) % count : clamp(target, 0, count - 1);
        index = nextIndex;
        track.style.transform = `translate3d(${-100 * index}%,0,0)`;
        dots.forEach((dot, i) => {
          dot.classList.toggle('is-active', i === index);
          dot.setAttribute('aria-current', String(i === index));
        });
        if (prev) prev.disabled = (index === 0);
        if (next) next.disabled = (index === count - 1);
      };
      gallery.addEventListener('pointerenter', e => {
        if (e.pointerType !== 'mouse' || isDown) return;
        clearTimeout(hoverTimer);clearTimeout(leaveTimer);
        hoverTimer = setTimeout(() => { if (!isDown && index === 0) go(1); }, 100);
      });
      gallery.addEventListener('pointerleave', e => {
        clearTimeout(hoverTimer);
        if (e.pointerType === 'mouse' && !isDown) {clearTimeout(leaveTimer);leaveTimer=setTimeout(()=>{if(!gallery.matches(':hover')) go(0);},270);}
      });
      gallery.addEventListener('focusout', e => {
        if (!gallery.contains(e.relatedTarget) && !gallery.matches(':hover')) go(0);
      });
      prev?.addEventListener('click', e => {e.preventDefault();e.stopPropagation();clearTimeout(hoverTimer);go(index - 1);});
      next?.addEventListener('click', e => {e.preventDefault();e.stopPropagation();clearTimeout(hoverTimer);go(index + 1);});
      dots.forEach(dot => dot.addEventListener('click', e => {
        e.preventDefault();e.stopPropagation();clearTimeout(hoverTimer);
        go(parseInt(dot.dataset.gocceV4Dot,10) || 0);
      }));
      // Touch horizontal swipe; a vertical gesture is left for ordinary page scrolling.
      gallery.addEventListener('pointerdown', e => {
        if (e.pointerType === 'mouse' || e.target.closest('button')) return;
        isDown = true; dragged = false; downX = e.clientX; downY = e.clientY; downAt = Date.now();
      });
      gallery.addEventListener('pointermove', e => {
        if (!isDown || e.pointerType === 'mouse') return;
        if (Math.abs(e.clientX - downX) > 16 && Math.abs(e.clientX - downX) > Math.abs(e.clientY - downY) * 1.15) dragged = true;
      });
      gallery.addEventListener('pointerup', e => {
        if (!isDown) return;
        isDown = false;
        const dx = e.clientX - downX;
        if (dragged && Math.abs(dx) >= 35) {
          go(index + (dx < 0 ? 1 : -1));
          ignoreLinkUntil = Date.now() + 600;
        }
      });
      gallery.addEventListener('pointercancel', () => { isDown = false; });
      slideLink?.addEventListener('click', e => {
        if (Date.now() < ignoreLinkUntil || dragged && Date.now() - downAt < 700) {
          e.preventDefault();e.stopPropagation();dragged = false;
        }
      }, true);
      // Keyboard arrows from gallery controls, without affecting global navigation.
      gallery.addEventListener('keydown', e => {
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
          e.preventDefault();go(index + (e.key === 'ArrowRight' ? 1 : -1));
        }
      });
      go(0);
    });
  }

  let activeFilter = null;
  let lastFilterFocus = null;
  function setFilter(layer, open) {
    if (!layer) return;
    const button = d.querySelector(`[data-gocce-filter-open][aria-controls="${layer.id}"]`);
    if (open && activeFilter && activeFilter !== layer) setFilter(activeFilter,false);
    if (open) {
      lastFilterFocus = d.activeElement;
      layer.inert = false;
      layer.classList.add('is-open');
      layer.setAttribute('aria-hidden','false');
      d.body.classList.add('gocce-v4-dialog-open');
      activeFilter = layer;
      button?.setAttribute('aria-expanded','true');
      layer.querySelector('[data-gocce-filter-close]:not(.gocce-v4-filter-backdrop)')?.focus({preventScroll:true});
    } else {
      layer.classList.remove('is-open');
      layer.setAttribute('aria-hidden','true');
      layer.inert = true;
      d.body.classList.remove('gocce-v4-dialog-open');
      button?.setAttribute('aria-expanded','false');
      if (activeFilter === layer) activeFilter = null;
      if (lastFilterFocus?.isConnected) lastFilterFocus.focus({preventScroll:true});
      lastFilterFocus = null;
    }
  }
  function initFilters(scope) {
    scope.querySelectorAll('[data-gocce-filter-layer]:not([data-v4-ready])').forEach(layer => {
      layer.dataset.v4Ready = '1';
      const opener = d.querySelector(`[data-gocce-filter-open][aria-controls="${layer.id}"]`);
      opener?.addEventListener('click', () => setFilter(layer, true));
      layer.querySelectorAll('[data-gocce-filter-close]').forEach(btn => btn.addEventListener('click', () => setFilter(layer, false)));
      layer.addEventListener('keydown', e => {
        if (e.key === 'Escape') {e.preventDefault();setFilter(layer,false);return;}
        if (e.key !== 'Tab') return;
        const focusable=[...layer.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled])')].filter(el => el.getClientRects().length && el !== layer.querySelector('.gocce-v4-filter-backdrop'));
        if (!focusable.length) return;
        if (e.shiftKey && d.activeElement === focusable[0]) {e.preventDefault();focusable.at(-1).focus();}
        else if (!e.shiftKey && d.activeElement === focusable.at(-1)) {e.preventDefault();focusable[0].focus();}
      });
    });
  }

  let openSort = null;
  const closeSort = menu => {
    if (!menu) return;
    menu.classList.remove('is-open');
    menu.querySelector('[data-gocce-sort-toggle]')?.setAttribute('aria-expanded','false');
    const options = menu.querySelector('[data-gocce-sort-options]');
    if (options) {options.inert=true;options.setAttribute('aria-hidden','true');}
    if (openSort === menu) openSort = null;
  };
  function initSorts(scope) {
    scope.querySelectorAll('[data-gocce-sort-menu]:not([data-v4-ready])').forEach(menu => {
      menu.dataset.v4Ready = '1';
      const toggle = menu.querySelector('[data-gocce-sort-toggle]');
      const options = menu.querySelector('[data-gocce-sort-options]');
      if (!toggle || !options) return;
      toggle.addEventListener('click', () => {
        const open = !menu.classList.contains('is-open');
        if (openSort && openSort !== menu) closeSort(openSort);
        menu.classList.toggle('is-open',open);
        toggle.setAttribute('aria-expanded',String(open));
        options.inert=!open;options.setAttribute('aria-hidden',String(!open));
        openSort=open?menu:null;
        if (open) options.querySelector('[aria-current="true"]')?.focus({preventScroll:true});
      });
      menu.querySelectorAll('[data-gocce-sort-choice]').forEach(button => button.addEventListener('click',() => {
        const sort = button.dataset.gocceSortChoice;
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by',sort);
        url.searchParams.delete('page');
        window.location.assign(url.toString());
      }));
      menu.addEventListener('keydown', e => {
        if (e.key === 'Escape') {closeSort(menu);toggle.focus();}
      });
    });
  }
  d.addEventListener('pointerdown', e => {
    if (openSort && !openSort.contains(e.target)) closeSort(openSort);
  });
  d.addEventListener('keydown', e => {
    if (e.key !== 'Escape') return;
    if (activeFilter) setFilter(activeFilter,false);
    if (openSort) closeSort(openSort);
  });

  function initRails(scope) {
    scope.querySelectorAll('[data-gocce-rail]:not([data-v4-ready])').forEach(rail => {
      rail.dataset.v4Ready = '1';
      const section = rail.closest('.gocce-v4-featured-section');
      const prev = section?.querySelector('[data-gocce-rail-prev]');
      const next = section?.querySelector('[data-gocce-rail-next]');
      const step = () => {
        const item = rail.querySelector('li');
        const second = item?.nextElementSibling;
        return second ? second.offsetLeft - item.offsetLeft : (item?.getBoundingClientRect().width || rail.clientWidth);
      };
      const update = () => {
        if(prev) prev.disabled = rail.scrollLeft < 8;
        if(next) next.disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 8;
      };
      prev?.addEventListener('click', () => rail.scrollBy({left:-step(),behavior:reduced()?'instant':'smooth'}));
      next?.addEventListener('click', () => rail.scrollBy({left:step(),behavior:reduced()?'instant':'smooth'}));
      rail.addEventListener('scroll',update,{passive:true});
      window.addEventListener('resize',update,{passive:true});
      update();
    });
  }
  function initMenuSubmenus(scope) {
    scope.querySelectorAll('[data-gocce-sub-toggle]:not([data-v4-ready])').forEach(button => {
      button.dataset.v4Ready = '1';
      button.addEventListener('click',() => {
        const parent=button.closest('.gocce-v4-menu-item');
        const expanded=!parent?.classList.contains('is-expanded');
        parent?.classList.toggle('is-expanded', expanded);
        button.setAttribute('aria-expanded',String(expanded));
      });
    });
  }
  function initDetailGallery(scope) {
    const image=scope.querySelector('[data-main-image]');
    const thumbs=[...scope.querySelectorAll('[data-gallery-thumb]')];
    const prev=scope.querySelector('[data-gocce-detail-prev]');
    const next=scope.querySelector('[data-gocce-detail-next]');
    if (!image || thumbs.length<2 || !prev || !next || prev.dataset.v4Ready) return;
    prev.dataset.v4Ready='1';
    const main=scope.querySelector('[data-product-main]');
    const move = dir => {
      const current = Math.max(0,thumbs.findIndex(btn => btn.classList.contains('is-active')));
      const destination=thumbs[(current+dir+thumbs.length)%thumbs.length];
      if (!destination) return;
      main?.classList.add('is-changing');
      if (reduced()) {destination.click();main?.classList.remove('is-changing');}
      else setTimeout(()=>{destination.click();main?.classList.remove('is-changing');},125);
    };
    prev.addEventListener('click',()=>move(-1));
    next.addEventListener('click',()=>move(1));
  }
  let toastTimer;
  function showToast(message, link = false) {
    let toast = d.querySelector('.gocce-v4-cart-toast');
    if (!toast) {toast=d.createElement('div');toast.className='gocce-v4-cart-toast';toast.setAttribute('role','status');toast.setAttribute('aria-live','polite');d.body.append(toast);}
    toast.replaceChildren(d.createTextNode(message));
    if (link) {const a=d.createElement('a');a.href=(window.Shopify?.routes?.root||'/')+'cart';a.textContent='Sepeti gör';toast.append(a);}
    toast.classList.add('is-shown');clearTimeout(toastTimer);
    toastTimer=setTimeout(()=>toast.classList.remove('is-shown'),4000);
  }
  function initQuickAdd(scope) {
    scope.querySelectorAll('[data-gocce-v4-card-add]:not([data-v4-ready])').forEach(form => {
      form.dataset.v4Ready='1';
      form.addEventListener('submit',async e=>{
        if (!window.fetch || !window.FormData) return;
        e.preventDefault();
        const button=form.querySelector('button[type="submit"]');
        if (button?.disabled) return;
        const original=button?.textContent;
        if(button){button.disabled=true;button.textContent='Ekleniyor…';}
        const root=window.Shopify?.routes?.root||'/';
        try {
          const response=await fetch(root+'cart/add.js',{method:'POST',body:new FormData(form),headers:{Accept:'application/json','X-Requested-With':'XMLHttpRequest'},credentials:'same-origin'});
          const result=await response.json();
          if(!response.ok) throw new Error(result.description || 'Ürün sepete eklenemedi.');
          const cart=await fetch(root+'cart.js',{credentials:'same-origin'}).then(r=>r.ok?r.json():null).catch(()=>null);
          if(cart) d.querySelectorAll('[data-cart-count]').forEach(el=>el.textContent=String(cart.item_count));
          showToast('Ürün sepete eklendi.',true);
        } catch (err) {showToast(err.message || 'Sepete eklenemedi.');}
        finally {if(button){button.disabled=false;button.textContent=original;}}
      });
    });
  }

  function init(scope) {
    initGalleries(scope);initFilters(scope);initSorts(scope);initRails(scope);initMenuSubmenus(scope);
    initDetailGallery(scope);initQuickAdd(scope);
  }
  init(d);
  d.addEventListener('shopify:section:load',e=>init(e.target));
})();
